import React from 'react';

export const ChildWorkflowIcon = () => {
  return (
    <svg
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.25 1.5C0.25 1.08579 0.585786 0.75 1 0.75H13C13.4142 0.75 13.75 1.08579 13.75 1.5V7C13.75 7.41421 13.4142 7.75 13 7.75H10.5C10.0858 7.75 9.75 7.41421 9.75 7C9.75 6.58579 10.0858 6.25 10.5 6.25H12.25V2.25H1.75V6.25H3.5C3.91421 6.25 4.25 6.58579 4.25 7C4.25 7.41421 3.91421 7.75 3.5 7.75H1C0.585786 7.75 0.25 7.41421 0.25 7V1.5ZM0.25 16.5C0.25 16.9142 0.585786 17.25 1 17.25H13C13.4142 17.25 13.75 16.9142 13.75 16.5V11C13.75 10.5858 13.4142 10.25 13 10.25H10.5C10.0858 10.25 9.75 10.5858 9.75 11C9.75 11.4142 10.0858 11.75 10.5 11.75H12.25V15.75H1.75V11.75H3.5C3.91421 11.75 4.25 11.4142 4.25 11C4.25 10.5858 3.91421 10.25 3.5 10.25H1C0.585786 10.25 0.25 10.5858 0.25 11V16.5ZM7.53033 6.46967C7.23744 6.17678 6.76256 6.17678 6.46967 6.46967L4.46967 8.46967C4.17678 8.76256 4.17678 9.23744 4.46967 9.53033C4.76256 9.82322 5.23744 9.82322 5.53033 9.53033L6.25 8.81066V14C6.25 14.4142 6.58579 14.75 7 14.75C7.41421 14.75 7.75 14.4142 7.75 14V8.81066L8.46967 9.53033C8.76256 9.82322 9.23744 9.82322 9.53033 9.53033C9.82322 9.23744 9.82322 8.76256 9.53033 8.46967L7.53033 6.46967Z"
        fill="#111111"
      />
    </svg>
  );
};
